import React, { Suspense } from "react"
import ReactDOM from "react-dom/client"
import reportWebVitals from "./reportWebVitals"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Logout from "./Common/jsx/Logout"
import "./Common/js/i18n"
import { ModalProvider } from "./Common/jsx/ModalProvider"
import { NotificationProvider } from "./Common/jsx/NotificationContext"
import MainApp from "./Common/jsx/MainApp"

const root = ReactDOM.createRoot(document.getElementById("root"))

let entityRoutes = [
  {
    entityPage: "splash",
    routes: [
      {
        url: "/",
      },
      {
        url: "/splash",
      },
    ],
  },
  {
    entityPage: "ggplants",
    routes: [
      {
        url: "/plants",
      },
      {
        url: "/plants/:id",
      },
    ],
  },
  {
    entityPage: "forgot_password",
    routes: [
      {
        url: "/forgot_password",
      },
      {
        url: "/forgot_password/:forgot_password_token",
      },
    ],
  },
  {
    entityPage: "dashboard",
    routes: [
      {
        url: "/admin",
        pageMenu: "dashboard",
      },
      {
        url: "/admin/dashboard",
        pageMenu: "dashboard",
      },
    ],
  },
  {
    entityPage: "todo",
    routes: [
      {
        url: "/admin/todo",
      },
    ],
  },
  {
    entityPage: "my_profile",
    routes: [
      {
        url: "/admin/my_profile",
      },
    ],
  },
]

let entities = ["users", "plants", "families", "charac_types", "characteristics"]

entities.forEach((entity) => {
  entityRoutes.push({
    entityPage: entity,
    routes: [
      {
        url: "/admin/" + entity,
        pageMenu: entity,
      },
      {
        url: "/admin/" + entity + "/add",
        pageType: "form",
        pageMenu: entity,
      },
      {
        url: "/admin/" + entity + "/edit/:id",
        pageType: "form",
        pageMenu: entity,
      },
    ],
  })
})

let routes = entityRoutes.flatMap((entityRoute) =>
  entityRoute.routes.map((route, index) => (
    <Route
      key={index}
      path={route.url}
      element={
        <ModalProvider>
          <NotificationProvider>
            <MainApp key={route.url} entityPage={entityRoute.entityPage} pageMenu={route.pageMenu} pageType={route.pageType !== undefined ? route.pageType : "list"} />
          </NotificationProvider>
        </ModalProvider>
      }
    />
  )),
)

root.render(
  <Suspense fallback={<div></div>}>
    <BrowserRouter>
      <Routes>
        {routes}
        <Route path="/logout" element={<Logout />} />
      </Routes>
    </BrowserRouter>
  </Suspense>,
)

//strictmode
// root.render(
//   <StrictMode>
//     <Suspense fallback={<div></div>}>
//       <BrowserRouter>
//         <Routes>
//           {routes}
//           <Route path="/logout" element={<Logout />} />
//         </Routes>
//       </BrowserRouter>
//     </Suspense>
//   </StrictMode>,
// )

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
